export class CombinedFamilyQuote {
    productName: string;
    price: number
}
